import { type PimProductV11 } from '@redteclab/api/clients/bully'

import { productAccessorVariantHasOffers } from './productAccessorVariantHasOffers'

export const productAccessorVariantHasMultipleOffers = (
  variant: PimProductV11,
): boolean => {
  if (!variant.offers || !productAccessorVariantHasOffers(variant)) {
    return false
  }

  return variant.offers.length > 1
}
